import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer-div">
        <p className="footer-text">
          Made with <span role="img">❤️</span> by  <a href="www.instagram.com/_creocodigo_">Creo-Codigo</a>
        </p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Footer.js